import { createContext, useContext, ReactNode } from 'react';
import { useHomeDetails } from '../hooks/useHomeDetails';

interface HomeData {
  chat_name: string;
  details: string;
}

interface HomeDetailsContextType {
  homeId: string;
  homeData: HomeData | null;
  loading: boolean;
  error: string | null;
  isSubmitting: boolean;
  editHome: (
    homeName: string, 
    address: string, 
    details: {
      bedrooms: number;
      bathrooms: number;
      sqft: number;
      price: number;
    }
  ) => Promise<{
    success: boolean;
    error?: string;
  }>;
  refreshHomeDetails: () => Promise<void>;
  setError: (error: string | null) => void;
}

const HomeDetailsContext = createContext<HomeDetailsContextType | undefined>(undefined);

interface HomeDetailsProviderProps {
  children: ReactNode;
  homeId: string;
}

export function HomeDetailsProvider({ children, homeId }: HomeDetailsProviderProps) {
  const homeDetails = useHomeDetails(homeId);
  
  return (
    <HomeDetailsContext.Provider value={{ 
      homeId,
      ...homeDetails
    }}>
      {children}
    </HomeDetailsContext.Provider>
  );
}

export function useHomeDetailsContext() {
  const context = useContext(HomeDetailsContext);
  if (context === undefined) {
    throw new Error('useHomeDetailsContext must be used within a HomeDetailsProvider');
  }
  return context;
}